import { http } from '../plugins/http'
import type { AxiosResponse } from 'axios'

import type PaginatedResponse from '@/types/PaginatedResponse'
import type Reading from '@/types/Reading'
import type DataResponse from '@/types/DataResponse'
import { OverviewSignatureItem } from '@/types/Overview'

export default class ReadingService {
  async index(event_id: string, page: number, filters: string, per_page: number | undefined = 10): Promise<AxiosResponse<PaginatedResponse<Reading[]>>> {
    return await http.get<PaginatedResponse<Reading[]>>(`/api/v1/office/readings/${event_id}?page=${page}&${filters}&per_page=${per_page}`)
  }

  async report(filters: string, selected: Record<string, string>): Promise<AxiosResponse<BlobPart>> {
    filters = (filters !== '') ? `?${filters}` : ''
    return await http.post(`/api/v1/office/readings${filters}`,
      { selected },
      {
        headers: {
          Accept: 'application/csv',
        },
      },
    )
  }

  async updateSignatureReadings(event_id: string, readings: OverviewSignatureItem[]) {
    return await http.put(`/api/v1/office/readings/${event_id}/signature`, { readings })
  }

  /**
   * Responds with the CSV import report. The response type is left as JSON so that
   * validation errors still reach the snackbar interceptor parsed; axios falls back
   * to the raw text for the CSV.
   */
  async import(event_id: string, file: File, origin: string): Promise<AxiosResponse<string>> {
    const form = new FormData()

    form.append('file', file)

    if (origin.trim() !== '') {
      form.append('origin', origin.trim())
    }

    return await http.post<string>(`/api/v1/office/readings/${event_id}/import`, form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  }

  async clear(event_id: string): Promise<AxiosResponse<DataResponse<null>>> {
    return await http.delete(`/api/v1/office/readings/${event_id}`)
  }
}
